import { render, staticRenderFns } from "./downloadModal.vue?vue&type=template&id=7c12175a&scoped=true&"
import script from "./downloadModal.vue?vue&type=script&lang=ts&"
export * from "./downloadModal.vue?vue&type=script&lang=ts&"
import style0 from "./downloadModal.vue?vue&type=style&index=0&id=7c12175a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c12175a",
  null
  
)

export default component.exports